'use client';

import { BodyFontFamilyNames, TitleFontFamilyNames } from "../themes.types.js";
const getThemedFontFamilyName = (fontFamily) => {
  if (Object.keys(BodyFontFamilyNames).includes(fontFamily)) {
    return BodyFontFamilyNames[fontFamily];
  }
  if (Object.keys(TitleFontFamilyNames).includes(
    fontFamily
  )) {
    return TitleFontFamilyNames[fontFamily];
  }
  return fontFamily;
};
export {
  getThemedFontFamilyName
};
